/** Meta pixel of Vechtsport Kids Ready (Dutch copy): "pixel martial arts nl" 2546249665877855.
 *  NEVER the English (1694960845480040), German (1457228929623029) or French (1660443269144667) Martial pixel.
 *  PageView on load, ViewContent when the offer section is seen, InitiateCheckout ONLY on the offer button. */
export const META_PIXEL_ID: string = '2546249665877855';
